import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/travis-med-ai.github.io/travis-med-ai.github.io/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 align="center">
  <a href="https://travis-med-ai.github.io">
    <img align="center" alt="Travis AI" src="https://raw.githubusercontent.com/Travis-Med-AI/med-ai/master/logo.svg" width="60" />
  </a>
    </h3>
    <h2 align="center">
  Travis Med AI
    </h2>
    <h3 align="center">
  Simplified AI in a clinical Setting
    </h3>
  Travis Med AI is an open source AI framework based on Docker to help streamline machine learning integration into the clinic.
    <h3 align="center">
  <a href="https://github.com/travis-med-ai/med-ai/blob/master/LICENSE.md">
    <img src="https://img.shields.io/badge/license-ASL-blue.svg" alt="Travis Med AI is released under the MIT license." />
  </a>
  <a href="https://travis-med-ai.github.io/contributing/how-to-contribute/">
    <img src="https://img.shields.io/badge/PRs-welcome-brightgreen.svg" alt="PRs welcome!" />
  </a>
    </h3>
    <h3 align="center">
  <a href="https://travis-med-ai.github.io/installation">Installation/Quickstart</a>
  <span> · </span>
  <a href="https://travis-med-ai.github.io/tutorial">Tutorial</a>
  <span> · </span>
  <a href="https://travis-med-ai.github.io/models">Models</a>
  <span> · </span>
  <a href="https://travis-med-ai.github.io/contributing/how-to-contribute/">Contribute</a>
    </h3>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      